import { useState } from 'react';
import { Outlet } from 'react-router-dom';
import PortalHeader from './PortalHeader';
import PortalSidebar from './PortalSidebar';
import { DeactivatedAccountBanner } from '@/components/common/DeactivatedAccountBanner';
import AIChatBubble from '@/components/AIChatBubble';

const PortalLayout = () => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);

  return (
    <div className="min-h-screen bg-background">
      <PortalHeader onMenuToggle={() => setIsSidebarOpen(!isSidebarOpen)} />
      <div className="flex">
        <PortalSidebar
          isOpen={isSidebarOpen}
          onClose={() => setIsSidebarOpen(false)}
        />
        <main className="flex-1 p-4 md:p-6 w-full">
          <DeactivatedAccountBanner />
          <Outlet />
        </main>
      </div>
      <AIChatBubble portalType="monument" />
    </div>
  );
};

export default PortalLayout;